import { ca } from '@cian/analytics';

export function trackScrollToCallToAction(clickedFrom: 'main' | 'deal_process' | 'price' | 'basement') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: `GoToForm/${clickedFrom}`,
  });
}
